export default "<div *ngIf=\"show\" class=\"ysh-new-features-tooltip\" (click)=\"didTapTooltip()\">\n  <p>{{ featureDescription }}</p>\n</div>\n";